import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// Register Service Worker for Push Notifications
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('SW registered: ', registration);
        // Check for a new deploy shortly after load and then periodically, so
        // long-lived tabs learn about updates without a manual refresh.
        setTimeout(() => registration.update().catch(() => {}), 10000);
        setInterval(() => registration.update().catch(() => {}), 15 * 60 * 1000);
      })
      .catch(registrationError => {
        console.log('SW registration failed: ', registrationError);
      });
  });

  // The SW uses skipWaiting + clients.claim, so a new version takes control as
  // soon as it installs. Reload once so this tab actually runs the new bundle
  // (otherwise open tabs keep executing stale JS until a manual refresh).
  // Distinguish "first SW claiming a fresh visit" (no reload) from "new SW
  // replacing the old one after a deploy" (reload): only pages that started
  // life already controlled reload on a controller change.
  const hadController = !!navigator.serviceWorker.controller;
  let reloadedForUpdate = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!hadController || reloadedForUpdate) return;
    reloadedForUpdate = true;
    window.location.reload();
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
